import Navbar from "@/components/LandingPage/Navbar";
import Footer from "@/components/LandingPage/Footer";
import { motion } from "framer-motion";

export default function Terms() {
  return (
    <div className="bg-bg-primary min-h-screen flex flex-col">
      <Navbar />
      <main className="grow pt-32 pb-20 px-6">
        <div className="mx-auto max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-12"
          >
            <h1 className="font-display text-4xl sm:text-5xl mb-6 text-text-primary">
              Terms of <span className="text-ember">Service</span>
            </h1>
            <p className="text-text-muted text-sm uppercase tracking-widest font-bold mb-8">
              Last Updated: March 26, 2026
            </p>
          </motion.div>

          <div className="prose prose-invert max-w-none text-text-muted leading-relaxed space-y-8">
            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing and using MineMe, you agree to be bound by these
                Terms of Service. If you do not agree to these terms, please do
                not use our platform. MineMe provides high-yield investment
                management services across various sectors including crypto
                mining and bullion trading.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                2. Eligibility
              </h2>
              <p>
                You must be at least 18 years old or the age of majority in your
                jurisdiction to use this platform. By creating an account, you
                represent and warrant that you meet these eligibility
                requirements.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                3. Investment Risks
              </h2>
              <p>
                Investments in high-yield portfolios involve significant risk.
                While MineMe employs rigorous risk management and features like
                Stop-Loss protection, past performance is not indicative of
                future results. You should only invest capital that you can
                afford to lose.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                4. Account Security
              </h2>
              <p>
                You are responsible for maintaining the confidentiality of your
                account credentials and for all activities that occur under your
                account. MineMe is not liable for any loss resulting from
                unauthorized access to your account.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                5. Withdrawals and Fees
              </h2>
              <p>
                Withdrawals are processed according to the plan terms. Early
                withdrawals are subject to a 27% processing fee. Cryptocurrency
                network fees may apply to all on-chain transactions.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
